import { StandaloneTable, TableFilters } from '@optimus-web/core';
import { ErrorHandler } from '@mews-commander/ui';

interface PaymentTableProps<T, F extends TableFilters<T> = TableFilters<T>>
    extends React.ComponentProps<typeof StandaloneTable<T, F>> {
    isError: boolean;
    onTryAgain: () => void;
}

export const PaymentTable = <T, F extends TableFilters<T>>({
    onTryAgain,
    isError,
    ...other
}: PaymentTableProps<T, F>) => {
    if (isError) {
        return <ErrorHandler onTryAgain={onTryAgain} />;
    }

    return <StandaloneTable {...other} />;
};
